<template>
  <div class="main-page page-xundian">
    <HomeHead :show="false"
              :logo="pointConfig.log || 'https://qiniu.laway.cn/yn/2023/08/02/eddbcec6311b11ee9d53b4055d0b07be.png'" />
    <div class="content-top">
      <div class="c-left">
        <div class="video-panel">
          <video controls
                 controlslist="nodownload"
                 id="videopanel"
                 poster="/img/banner/bg_video.jpg"
                 webkit-playsinline="true"
                 style="width: 100%; display: block; height:100%;">
            <source :src="currentVideo.video"
                    type="video/mp4">
          </video>
        </div>
      </div>
      <div class="c-center">
        <VideoConsult />
        <QLink :item="advisory"
               class="c2 flex-col" />
        <QLink :item="xybl"
               clickable
               @clickable="toXyAdvisory('6E9F8142E62C44EDA30A8070E0DF22D4')"
               class="c3 flex-col" />
        <QLink :item="legalaid"
               class="c4 flex-col" />
        <QLink :item="xyxq"
               clickable
               @clickable="toXyAdvisory('92B3DA88430D485AB01BBC12A166A051')"
               class="c5 flex-col" />
        <QLink :item="mediation"
               class="c6 flex-col" />
      </div>
      <div class="c-right">
        <div class="teenage">
          <div class="title">青少年心理咨询包</div>
          <div class="content">
            <div class="item txtetc"
                 @click="$router.push('/post/' + item.id + '?title=详情')"
                 v-for="(item, index) in list"
                 :key="'keys' + index">
              {{ item.title }}
            </div>
          </div>
        </div>
        <QLink :item="cxfw"
               style="margin:0"
               class="c7 flex-col" />

      </div>
    </div>
    <div class="video-list-panel">
      <div class="swiper-container grayscale"
           id="swiper-video-container"
           v-show="videoList.length">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
               v-for="(v, index) in videoList"
               :key="'keys--' + index">
            <div :class="{ 'item': true, 'active': currentVideo.index == index }"
                 @click="playVideo(v, index)">
              <div class="banner">

                <img :src="v.img.length && v.img[0] || '/img/banner/bg_video.jpg'"
                     alt="">
              </div>
              <div class="title txtone">

                {{ v.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next arrow-panel"></div>
        <div class="swiper-button-prev arrow-panel"></div>
      </div>
    </div>
    <HomeFoot />
  </div>
</template>
<script>
import HomeHead from '@/components/home/HomeHead'
import HomeFoot from '@/components/home/HomeFoot'
import HomefloatAd from '@/components/home/HomefloatAd'
import VideoConsult from '@/components/home/VideoConsult'
import QLink from '@/components/home/QLink'
import Rightslide from '@/components/RightSlide'
import api from '@/datas/js/api'
export default {
  components: {
    Rightslide,
    HomeHead,
    HomeFoot,
    HomefloatAd,
    VideoConsult,
    QLink
  },
  data () {
    return {
      currentVideo: '',
      videoList: [],
      list: [],
      mediation: {
        title: '人民调解',
        path: '/service/0',
        icon: '/img/ui/videohome/icon_tiaojie_90.png'
      },
      advisory: {
        title: '精准法律咨询',
        origin: 'advisory',
        icon: '/img/ui/videohome/icon_advisory_90.png',
      },
      legalaid: {
        title: '法律援助',
        path: '/service/6',
        icon: '/img/ui/videohome/icon_aid_90.png'
      },
      xybl: {
        title: '校园暴力法律咨询',
        icon: '/img/ui/videohome/icon_xybl_90.png'
      },
      xyxq: {
        title: '校园性侵法律咨询',
        icon: '/img/ui/videohome/icon_xyxq_90.png'
      },
      cxfw: {
        title: '查询服务',
        icon: '/img/ui/videohome/icon_cx_90.png',
        path: '/service/12'

      }
    }
  },
  computed: {
    appList () {
      return this.$store.state.app.appList
    },
    pointConfig () {
      return this.$point.config ? JSON.parse(this.$point.config) : {}
    }

  },
  created () {
    this.$store.dispatch('app/getAppList')
  },
  async mounted () {
    await this.getList()
    await this.getPufaVideo()
    this.$nextTick(() => {
      this.currentVideo = this.videoList.length ? Object.assign(this.videoList[0], { index: 0 }) : ''
    })
    this.initSwiper()
  },
  methods: {
    async getPufaVideo () {
      const { result, status } = await this.$get(`${api.list}64c24a827edc016d1b9f668d`, this)
      if (status) {
        this.videoList = result.data.items
      }
    },
    async getList () {
      const { result, status } = await this.$get(`${api.list}64c24ac37edc016d1b9f6746`, this)
      if (status) {
        this.list = result.data.items
      }
    },
    initSwiper () {
      this.$nextTick(() => {
        new Swiper('#swiper-video-container', {
          slidesPerView: 6,
          spaceBetween: 15,
          autoplay: {
            delay: 235000,
            disableOnInteraction: false
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        })
      })
    },
    playVideo (item, index) {
      // play video
      this.currentVideo = Object.assign(item, { index })
      const machineId = this.$store.state.device.point.no
      this.$get(`/pufa/post/?post_id=${item.id}&machine_id=${machineId}&platform=ZD`)
      this.$nextTick(() => {
        document.querySelector('#videopanel').src = item.video
        document.querySelector('#videopanel').play()
        document.querySelector('#waitAudio').src = ''
        document.querySelector('#waitAudio').pause()
      })
    },
    toXyAdvisory (id) {
      const item = this.appList.find(v => v.id === id)
      if (item) {
        window.location.href = `${this.appSite}/terminal/g/${item.appOnlineId}?action=start`
      }
    },
  },

}
</script>
<style lang="stylus"  >
.page-xundian
  padding-top 0.14rem
  .content-top
    display flex
    overflow hidden
    padding 0 0.6rem
    justify-content space-between
    .c-left
      width 8.92rem
      .video-panel
        margin 0
        width 8.93rem
        height 5.72rem
        background-color rgba(0, 0, 0, 0.5)
        margin-bottom 0.15rem
    .c-center
      flex 1
      height 100%
      flex-wrap wrap
      margin-left 0.08rem
      display flex
      .home-video-consult
        margin 0 0.08rem
      .link-panel
        display flex
        flex-wrap wrap
        flex 1
        .q-link-item
          margin-bottom 0.14rem
    .c-right
      height 5.72rem
      width 2.88rem
      flex-shrink 0
      .teenage
        padding-bottom 0.24rem
        color #fff
        height 3.78rem
        background-image linear-gradient(-180deg, #0066e5 0%, #4798fc 100%)
        display flex
        flex-direction column
        margin-bottom 0.13rem
        .title
          font-size 0.24rem
          padding 0.2rem 0.24rem
        .content
          flex 1
          overflow-y auto
          &::-webkit-scrollbar
            width 5px
          &::-webkit-scrollbar-thumb
            border-radius 4px
            -webkit-box-shadow inset 0 0 5px rgba(255, 255, 255, 0.2)
            background #fff
          &::-webkit-scrollbar-track
            -webkit-box-shadow inset 0 0 5px rgba(255, 255, 255, 0.2)
            border-radius 2px
            background rgba(255, 255, 255, 0.2)
          .item
            font-size 0.18rem
            padding 0 0.24rem 0 0.58rem
            margin-bottom 0.14rem
            overflow hidden
            background-image url('https://qiniu.laway.cn/yn/2023/08/02/cfbcce2230e411ee9d53b4055d0b07be.png')
            background-size 0.24rem
            background-repeat no-repeat
            background-position-x 0.24rem
            background-position-y 0.05rem
  .video-list-panel
    padding 0 0.6rem
    margin-top 0.15rem
    .swiper-container
      height 2.4rem
      padding 0 0.5rem
    .arrow-panel
      position absolute
      top 0.1rem
      width 0.36rem
      height 1.92rem
      line-height 2rem
      padding 0
      text-align center
      background-color rgba(0, 0, 0, 1)
      background-image url('https://qiniu.laway.cn/publaw/782300a2310511ee950e52540086b33f.png')
      background-size 12px
      z-index 10
      color #fff
      &.swiper-button-prev
        left 0
      &.swiper-button-next
        right 0
        transform rotate(180deg)
    .item
      .banner
        position relative
        width 2.7rem
        height 1.8rem
        overflow hidden
        background-color rgba(0, 0, 0, 0.5)
        box-sizing border-box
        &:before
          content ''
          position absolute
          top 50%
          left 50%
          transform translate(-50%, -50%)
          width 0.5rem
          height 0.5rem
          background-image url('https://qiniu.laway.cn/publaw/76d995e6310311ee950e52540086b33f.png')
          background-size 100%
        img
          width 100%
          height 100%
      &.active
        .banner
          border solid 1px #f1923e
      .title
        color #fff
        font-size 0.2rem
        margin-top 0.15rem
.page-xundian + .control
  display none
</style>
